import styles from "./Services.module.css";

function ServiceCard({ id, img, title, description, tick }) {
  return (
    <div className={styles.card}>
      <div className={styles.tag}>
        <div className={styles.number}>{id}</div>
        <div className={styles.tick}>
          <img src={tick.img} alt={tick.alt} />
        </div>
      </div>

      <div className={styles.imgBox}>
        <img src={img} alt={title} className={styles.img} />
      </div>

      <h3>{title}</h3>

      <p>{description}</p>
    </div>
  );
}

export default ServiceCard;
